import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';
import { BerthProfile, BerthProfileParams } from './model';
import { BerthProfileView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';

export const BerthProfileRoute = (model : (params : BerthProfileParams) => BerthProfile, appWrapper : AppWrapper, request : Location) : IRoute => {
    const m = model(inboundParams(request));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <BerthProfileView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
};

function inboundParams(request : Location) : BerthProfileParams {
    const id = parseInt(request.params['id'] || '', 10),
        editName = !!request.params['editName'];
    if (isNaN(id)) throw new Error('BerthProfile: id param is required and must be numeric.');
    return { id, editName };
}

function outboundParams(request : Location, m : BerthProfile) {
    const params = {} as LocationParams;
    params['id'] = m.Id + '';
    if (m.AutoEditName()) params['editName'] = 'true';
    return new Location(request.name, params);
}


// WEBPACK FOOTER //
// ./apps/portcall/berthprofile/route.tsx